export {default} from "./CardPasajerosSmall"